import { Route, Switch, useRouteMatch } from "react-router";
import { ChooseYourMethod } from "./ChooseYourMethod";
import { EnterYourInfo } from "./enter-info/EnterYourInfo";
import { LoginSendCode } from "./login/LoginSendCode";
import { LoginEnterCode } from "./login/LoginEnterCode";
import { UpdateMfa } from "./edit-method/UpdateMfa";
import { RemoveMethod } from "./edit-method/RemoveMethod";
import { MfaNotAvailable } from "./MfaNotAvailable";
import { useFlags } from "launchdarkly-react-client-sdk";
import { EnrollEnterCode } from "./EnrollEnterCode";
import { globalData } from "../globalContext";
import { useContext, useEffect } from "react";
import ScrollToTop from "../common/functions/ScrollToTop";

export const SecurityCode = () => {
    const { path } = useRouteMatch();
    const { enableMfaPages } = useFlags();
    const { setEnableHeaderTimeout } = useContext(globalData);

    useEffect(() => {
        setEnableHeaderTimeout(true);

        return (() => {
            setEnableHeaderTimeout(false);
        })
    }, [setEnableHeaderTimeout]);

    if (!enableMfaPages) {
        return <MfaNotAvailable />
    }

    return (<>
        <ScrollToTop />
        <Switch>
            <Route path={`${path}/enroll/choose-your-method`}>
                <ChooseYourMethod flow='enroll' />
            </Route>
            <Route component={EnterYourInfo} path={`${path}/enroll/enter-your-info`} />
            <Route component={EnrollEnterCode} path={`${path}/enroll/confirm-your-method`} />
            {/* Mock uuid: 0c4699c8-6371-4949-8af5-a1b9236feb80 */}
            <Route component={UpdateMfa} path={`${path}/update-security-method/:uuid`} />
            <Route component={RemoveMethod} path={`${path}/remove-security-method/:uuid`} />
            <Route path={`${path}/add-security-method`}>
                <ChooseYourMethod flow='add' />
            </Route>

            <Route component={LoginSendCode} path={`${path}/login-send-code`} />
            <Route component={LoginEnterCode} path={`${path}/login-enter-code`} />
        </Switch>
    </>);
}